export type TomAssistantMode = 'voice' | 'text';

export const TOM_ASSISTANT_MODE_UPDATED_EVENT = 'tom-assistant-mode-updated';

export function isTomAssistantMode(value: unknown): value is TomAssistantMode {
  return value === 'voice' || value === 'text';
}

export function dispatchTomAssistantModeUpdated(mode: TomAssistantMode) {
  window.dispatchEvent(
    new CustomEvent(TOM_ASSISTANT_MODE_UPDATED_EVENT, { detail: { mode } })
  );
}
